import React, { useEffect } from "react";
import { useLoaderData, useLocation } from "react-router";

import { withPaywall } from "#/components/WithPaywall";
import { canViewNotification } from "#/lib/permissions";

type Event = {
  id: number;
  title: string;
  description: string;
  content: string;
};

type LoaderData = {
  data: Event;
};

function EventDetails() {
  const { data } = useLoaderData() as LoaderData;

  const title = data?.title;
  const content = data?.content;

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-muted dark:bg-background p-8 min-h-screen">
      <div className="max-w-4xl mx-auto bg-background p-6 rounded-lg shadow dark:border-2">
        <h1 className="text-3xl font-bold my-2 font-title">{title}</h1>
        <div
          className="text-lg text-foreground"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}

export default withPaywall(EventDetails, canViewNotification);
